import i18n from "../i18n";
import globalConfig from '../config/global/config.json';
import find from 'lodash/find';
import { createLogs } from './proactiveMonitoring';

export const anyConsentsChecked = consents => {

    for(let consent of consents){
      if(consent.isChecked)
        return true;
    }

    return false;
} 

export const orderConsents = consents => {
  let orderedConsents;
    const consentOrder = i18n.exists("configuration:SET_CONSENT_ORDER") ? i18n.t("configuration:SET_CONSENT_ORDER", { returnObjects: true }) : globalConfig["SET_CONSENT_ORDER"];
      orderedConsents = consentOrder.map(function(obj) {
      return find(consents, function(consentObj){
        if(consentObj.name === obj)
          return {isChecked: obj.isChecked};
        });
    });
    if (i18n.exists("configuration:SET_DYNAMIC_CONSENT") && sessionStorage.getItem('channel')) {
      const channels = sessionStorage.getItem('channel');
        const channelArray = channels.split(',');
        let channelConsent = channelArray.map( channel => {
          return consents.find(consent => {
            if(consent.name.toLowerCase() === channel.toLowerCase()) {
              return {isChecked: consent.isChecked};
            }
          })
        })
        channelConsent = channelConsent.filter(x=>x!==undefined);
        if (channelConsent.length > 0 ) {
          orderedConsents = channelConsent;
        }
        else {
          createLogs("2", {
            data: {
                message: `Invalid values in channel parameter - ${channels}`,
                emailId: sessionStorage.getItem('em'),
                userId: sessionStorage.getItem('id')
            },
            errorCode: "ERR_CSP-10011",
            locale: sessionStorage.getItem('locale'),
            requestName: "invalid_channel_parameters_dynamic_consent"
        });
        }
    }
    orderedConsents = orderedConsents.filter(x=>x!==undefined);
    const enableUnsubscribe = i18n.exists("configuration:SET_ENABLE_UNSUBSCRIBE_ALL") ? i18n.t("configuration:SET_ENABLE_UNSUBSCRIBE_ALL") : globalConfig["SET_ENABLE_UNSUBSCRIBE_ALL"];
    if(enableUnsubscribe){

      if (anyConsentsChecked(orderedConsents)) {
        orderedConsents.push({ name: "unsubscribeAll", isChecked: false });
      } else {
        orderedConsents.push({ name: "unsubscribeAll", isChecked: true });
      }
      
    }
    return orderedConsents;
  }

export const unsubscribeChannels = (consents) => {
  const channelToUnsubscribe = sessionStorage.getItem('channel');
  const unsubscribeChannelArray = channelToUnsubscribe.split(',');
  const consentsArray = [...consents];
  unsubscribeChannelArray.forEach((channel) => {
    consentsArray.map((consent) => {
      if (consent.name.toLowerCase() === channel.toLowerCase()) {
        consent.isChecked = false;
      }
      return consent;
    });
  });
  return consentsArray;
};